import IPButton from './IPButton'

export default IPButton
